module.exports = __webpack_public_path__ + "img/massageSet.86dc2632.svg";